import {
    FETCH_ARTICLES,
    CREATE_ARTICLE,
    UPDATE_ARTICLE,
    DELETE_ARTICLE,
} from '../actions/articles'

const initialState = {
    articleList: [],
    currentArticle: undefined,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_ARTICLES:
            return {
                ...state,
                articleList: action.payload,
            }

        case CREATE_ARTICLE:
        case UPDATE_ARTICLE:
            return {
                ...state,
                currentArticle: action.payload,
            }

        case DELETE_ARTICLE:
            return {
                ...state,
                currentArticle: undefined,
            }
        default:
            return state
    }
}
